import countries from "./countries";
import PhoneNumber from "awesome-phonenumber";

function validatePhoneNumber(phoneNumber) {
  const itemsCode = countries.map(country => country[2])
  const arrCode = itemsCode.filter(code => phoneNumber.includes(code))
  if (arrCode.length > 0) {
    return new Promise(resolve => {
      const phone = new PhoneNumber(phoneNumber);
      resolve({valid: phone.isValid()})
    });
  } else {
    const re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
    return re.test(phoneNumber);
  }
}

function validateNumberInput(value) {
  return /^[0-9]+$/.test(value);

}

function validateEmail(email) {
  const re =  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return re.test(String(email).toLowerCase());
}

function validateDomain(domain) {
  const re = new RegExp(/^((?:(?:(?:\w[\.\-]?)*)\w)+)((?:(?:(?:\w[\.\-]?){0,62})\w)+)\.(\w{2,6})$/);
  return domain.match(re);
}

function validateSubnet(subnet) {
  const re = /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9]{1,2})\/[0-9][0-9]$/;
  return re.test(subnet);
}

function validateIPaddress(ipaddress) {
  return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress);

}

function validateDnsServer(dnsServer) {
  return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\:([0-9]{1,5})$/.test(dnsServer);

}

function validatePortNumber(portNumber) {
  const re = /^([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/i;
  return re.test(portNumber);
}

function validatePortNumberRange(portNumberRange) {
  const listPortNumber = portNumberRange.split(',');
  for (const portNumber of listPortNumber) {
    const listPN = portNumber.split('-')
    if (listPN.length <= 1) {
      if (!validatePortNumber(portNumber.toString().trim())) {
        return false
      }
    } else if (listPN.length > 2) {
      return false
    } else if (!validatePortNumber(listPN[0].toString().trim()) || !validatePortNumber(listPN[1].toString().trim())) {
      return false
    }
  }
  return true
}

function validateIpAddressRange(ipAddressRange) {
  const listIpAddress = ipAddressRange.split(',');
  for (const ipAddress of listIpAddress) {
    if (ipAddress.toString().includes('/')) {
      const listPN = ipAddress.split('/')
      if (listPN.length > 2) {
        return false
      } else if (listPN[1].toString().length === 0 || listPN[1] > 32 || listPN[1] < 0 || !validateIPaddress(listPN[0])) {
        return false
      }
    } else {
      const listPN = ipAddress.split('-')
      if (listPN.length <= 1) {
        if (!(validateDomain(ipAddress.toString().trim())) && !(validateIPaddress(ipAddress.toString().trim()))) {
          return false
        }
      } else if (listPN.length > 2) {
        return false
      } else if (!validateIPaddress(listPN[0].toString().trim()) || !validateIPaddress(listPN[1].toString().trim())) {
        return false
      }
    }
  }
  return true

}


export const validate = {
  validateDomain,
  validateIPaddress,
  validatePortNumberRange,
  validatePhoneNumber,
  validateEmail,
  validatePortNumber,
  validateIpAddressRange,
  validateSubnet,
  validateNumberInput,
  validateDnsServer
}

